import { useSelector } from 'react-redux';
import { hostTypeSelector, currentOpenChatIDSelector } from '../../../selectors';
import { EHostType } from '../../../types/hostType';
import { useApplicationContext } from '../../../utils/applicationContext';
import { EDeviceType } from '../../../types/deviceType';

const MESSAGE_INPUT_HEIGHT = 60;
const BOTTOM_NAVIGATION_MENU_HEIGHT = 60;
const BOTTOM_OFFSET = 8;

export const useAlertOffset = () => {
  const {
    custom: { realDevice },
  } = useApplicationContext();
  const isDesktop = realDevice === EDeviceType.Desktop;

  const hostType = useSelector(hostTypeSelector);
  const isIframe = hostType === EHostType.Frame;

  const currentOpenedChatId = useSelector(currentOpenChatIDSelector);
  const hasOpenedChats = Boolean(currentOpenedChatId);

  if (isDesktop || isIframe) {
    return MESSAGE_INPUT_HEIGHT + BOTTOM_OFFSET;
  }

  if (hasOpenedChats) {
    return MESSAGE_INPUT_HEIGHT + BOTTOM_NAVIGATION_MENU_HEIGHT + BOTTOM_OFFSET;
  }

  return BOTTOM_NAVIGATION_MENU_HEIGHT + BOTTOM_OFFSET;
};
